import React, { useState, type FC } from 'react';
// @ts-ignore
import style from './FavoriteButton.module.scss?module';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from 'react-bootstrap';
import { useUser } from '../../../../Context/UserContext';
import UserLoginPopUp from '../../../Modals/UserLoginPopUp/UserLoginPopUp';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useProductsFilter } from '../../../../Context/ProductsFilterContext';

type FavoriteButtonPropsT = {
  erp_id: number;
  is_favorite: boolean;
  onUpdate?: () => void;
};

const FavoriteButton: FC<FavoriteButtonPropsT> = ({
  erp_id,
  is_favorite,
  onUpdate,
}) => {
  const { user, updateFavouritesCount } = useUser();
  const { filters } = useProductsFilter();
  const queryClient = useQueryClient();

  const [isFavorite, setFavorite] = useState(is_favorite);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // todo: postRequest hook muss angepasst werden dass body prop im callback fun akeptiert und umbennen zur usePostRequest
  const { mutateAsync: mutateFavorite, isPending } = useMutation({
    mutationFn: (body: '0' | '1') =>
      axios
        .get(
          `/api/onlineshop/product-sizes/${erp_id}/updateFavourite/${body}`,
          {
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        )
        .then((res) => res.data),
  });

  const handleFavoriteButtonClick = async () => {
    if (!user) return setShowLoginPopup(true);

    await mutateFavorite(isFavorite ? '0' : '1', {
      onSuccess: (data) => {
        const nextIsFavorite = !isFavorite;
        setFavorite(nextIsFavorite);
        updateFavouritesCount(data.unit_count);

        if (filters.favs_only === '1' && !nextIsFavorite) {
          const queryKeys = [
            'grid',
            'brand_ids',
            'category_ids',
            'sale_percent',
            'product_sizes_count'
          ];
          queryKeys.forEach((key) => {
            queryClient.invalidateQueries({ queryKey: [key] });
          });
        }

        onUpdate?.();
      },
    });
  };

  return (
    <UserLoginPopUp
      showLoginPopup={showLoginPopup}
      setShowLoginPopup={setShowLoginPopup}
    >
      <button
        type="button"
        className={[
          'text-white text-decoration-none d-flex align-items-center justify-content-center',
          isFavorite ? 'bg-primary' : 'bg-light-gray',
          style.favouriteButton,
        ].join(' ')}
        onClick={handleFavoriteButtonClick}
      >
        {isPending ? (
          <Spinner className="text-white" size="sm" animation="border" />
        ) : (
          <FontAwesomeIcon size="xl" icon={faHeart} />
        )}
      </button>
    </UserLoginPopUp>
  );
};

export default FavoriteButton;
